import { FINANCE_BASE, METADATA_BASE, PROFESSIONAL_BASE } from '@common/urlBasePath';
import { Product } from '@prophecy/graphql-types/enums';

import { useProductType } from './utils';

export const useProductConfig = () => {
  const productType = useProductType();

  if (productType === Product.Finance) {
    return {
      productType: Product.Finance,
      basePath: FINANCE_BASE
    };
  }

  if (productType === Product.Professional) {
    return {
      productType: Product.Professional,
      basePath: PROFESSIONAL_BASE
    };
  }

  return {
    productType: null,
    basePath: METADATA_BASE
  };
};
